export { default as GeneralInfo } from './GeneralInfo';
export { default as Visit } from './Visit';
